import { Card } from "./Layout";
import { Button } from "./ui/button";
import { monthName, nextMonthISO } from "../lib/api";

/** Pausa de un mes con reactivación automática (Centro de Estudios y Logopedia). */
export const PauseCard = ({ name, pauseMonth, accent = "centro", onPause, onCancel, testid }) => {
  const target = nextMonthISO();
  const future = pauseMonth && pauseMonth >= target;
  const running = pauseMonth && pauseMonth < target;
  const bg = accent === "logo" ? "bg-logo hover:bg-logo-hover" : "bg-centro hover:bg-centro-hover";

  return (
    <Card className="mb-8" data-testid={testid}>
      <h2 className="font-head text-2xl font-medium">Pausar la matrícula un mes</h2>
      <p className="mt-2 text-lg text-ink-700">
        La pausa debe solicitarse con un mes de antelación y dura como máximo un mes. Durante ese
        mes no se cobra cuota y la plaza queda libre. Al empezar el mes siguiente la matrícula se
        reactiva <strong>automáticamente</strong> con el mismo horario: no tendrá que hacer nada.
      </p>
      {running && (
        <p data-testid={`${testid}-running`} className="mt-4 rounded-xl bg-cream p-4 text-lg">
          {name} está en pausa durante {monthName(pauseMonth)}. Se reactivará automáticamente el mes
          siguiente con el mismo horario.
        </p>
      )}
      {future && (
        <div className="mt-4">
          <p data-testid={`${testid}-planned`} className="rounded-xl bg-cream p-4 text-lg">
            Pausa solicitada para {monthName(pauseMonth)}.
          </p>
          <Button data-testid={`${testid}-cancel-btn`} variant="outline" className="mt-3 h-14 text-lg"
            onClick={onCancel}>
            Anular la pausa solicitada
          </Button>
        </div>
      )}
      {!future && !running && (
        <Button data-testid={`${testid}-btn`} className={`mt-4 h-14 text-lg ${bg}`}
          onClick={() => onPause(target)}>
          Pausar {monthName(target)}
        </Button>
      )}
    </Card>
  );
};
